import React, { memo, useCallback } from 'react'
import cx from 'classnames'
import Paper from '@mui/material/Paper'
import { dismissPopover } from 'services/OverlayService'
import { ALL_AOLS } from 'constants/aol/aol'

const menuItemCx = 'f5 f6-t f7-m fw6 tracked-cosy no-underline max-w-12 focus-outline-0'

// markets tab links are always generated without an AOL prefix, but currentUrl
// (the real browser path) keeps whatever prefix was actually navigated to on
// first load - strip it so the comparison below isn't comparing mismatched paths
const stripAolPrefix = path => {
  const [first, ...rest] = path.split('/')
  return ALL_AOLS.includes(first) ? rest.join('/') : path
}

const MenuItem = memo(({ onClick, title, isLogged, url, currentUrl, setSignUpModalIsOpen }) => {
  const accessDenied = (!isLogged && title === 'Analytics')
  const handleOnClick = useCallback((e) => {
    if (accessDenied) {
      dismissPopover(e.target)
      e.preventDefault()
      e.stopPropagation()
      setSignUpModalIsOpen(true)
    } else {
      onClick && onClick(e)
    }
  }, [accessDenied, setSignUpModalIsOpen, onClick])
  const isCurrentUrl = stripAolPrefix(url.split('?')[0]) === stripAolPrefix(currentUrl)

  return (
    <a
      onClick={handleOnClick}
      href={url}
      className={menuItemCx}
      tabIndex='-1'
      data-event-category='Markets:Menu'
      data-event-action='Navigation'
      data-event-label={`[listdeals][${title}]`}
    >
      <Paper
        className='f6-m mh1 pv4 pv3-m tc nowrap min-w11'
        classes={{
          root: cx('br0 pa0', {
            'active bg-dark-sea-green-3 white': isCurrentUrl,
            'hover-default-tab-button-bg cadet-blue': !isCurrentUrl
          })
        }}
      >
        {title}
      </Paper>
    </a>
  )
})

export default MenuItem
